import React from "react";
import { observer } from "mobx-react";
import { PageLayout } from "../../../../common/layout";
import { useRootStore } from "../../../../store/contexts";
import { EsignatureRecipientView } from "./EsignatureRecipientView";
import { EsignatureRecipientViewStore } from "../../store/EsignatureRecipientViewStore";
import { useStore } from "../../../../hooks";

export const EsignatureRecipientViewPage = observer(() => {
  const rootStore = useRootStore();
  const { router } = rootStore;

  const id = router.params?.id as string;
  const path = `/esignatureRecipient/view/${id}`;

  const store = useStore(
    path,
    () => {
      const s = new EsignatureRecipientViewStore(rootStore);
      return s;
    },
    { id }
  );

  return (
    <div>
      <PageLayout
        navigationElements={{
          links: [],
          onNavigatedTo: (id) => {
            store.setCardState(id, true);
          },
        }}
      >
        <EsignatureRecipientView esignatureRecipientViewStore={store} />
      </PageLayout>
    </div>
  );
});
